import { Currency } from "components/CustomCurrency/currency";

function getTableData(data) {
  // param: data list of: [
  // {
  //   empresa: 'BIOALIMENTAR CIA. LTDA.',
  //   venta1: 59435181,
  //   sector: 'GANADERÍA / AVICULTURA / PEQUEÑAS ESPECIES / MICELÁNEOS',
  //   $$hashKey: 'uiGrid-000V'
  // }]

  var rows = [];
  data.forEach((elem, index) => {
    var _temp = {
      Nro: index + 1,
      company: elem.empresa,
      sector: elem.sector,
      total: <Currency value={elem.venta1} />,
    };
    rows.push(_temp);
  });

  // return values in a format that charts components understand
  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "5%" },
      { Header: "Empresa", accessor: "company" },
      { Header: "Sector", accessor: "sector" },
      { Header: "Total Ventas", accessor: "total", width: "20%" },
    ],
    rows: rows,
  };
}

export default getTableData;
